<template>
    <vue-scroll :ops="ops">
        <div class="casePage">
            <HeaderMei></HeaderMei>
            <div class="content">
                <div class="title">
                    <span></span>
                    政企合作<em>Government enterprise cooperation</em>
                    <i></i>
                </div>
                <div class="js">
                    美天科技主要专注于气象相关领域的业务系统研发和服务<br>
                    服务对象主要面向政府企事业单位以及各行业消费群体<br>
                    并与全国各省市气象单位建立了长期的战略合作关系
                </div>
                <div class="tabMain">
                    <div class="tabTitle">
                        <div class="titles" v-for="(item,index) in mapimgs" :class="{'select': item.selected}"
                             :key="index" @click="mapimgsChange(index)">
                            <p>{{item.name}}</p>
                            <span>{{item.subTitle}}</span>
                        </div>
                    </div>
                    <div class="mapimg">
                        <img :src="mapimgs[imgIndex].src">
                    </div>
                </div>
                <div class="sysListMain">
                    <div class="tabTitle">
                        <div class="t" v-for="(item,index) in sysLists" :class="{'select':item.selected}" :key="index"
                             @click="sysListMainChange(index)">
                            {{item.name}}
                        </div>
                    </div>
                    <div class="lists">
                        <div class="list" v-for="(item,index) in sysListpt" :key="index">
                            <i></i>{{item}}
                        </div>
                    </div>
                </div>
            </div>
            <FooterMei></FooterMei>
        </div>
    </vue-scroll>
</template>

<script>
import HeaderMei from '@/components/headerMei';
import FooterMei from '@/components/footerMei';

export default {
    name: 'casePage',
    components: { HeaderMei, FooterMei },
    data() {
        return {
            ops: {
                rail: {
                    background: '#01a99a',
                    opacity: 0,
                    size: '0px',
                    specifyBorderRadius: false,
                    gutterOfEnds: null,    // 轨道距 x 和 y 轴两端的距离
                    gutterOfSide: '0',   // 距离容器的距离
                    keepShow: false,   // 是否即使 bar 不存在的情况下也保持显示
                    border: 'none'    // 边框
                }
            },
            mapimgs: [
                { name: '合作省份', subTitle: '全国合作情况', src: './static/images/24.png', selected: true },
                { name: '气象业务合作', subTitle: '业务精细化,一体化升级', src: './static/images/25.png', selected: false },
                { name: '防灾减灾合作', subTitle: '助力构建人民安全防线', src: './static/images/26.png', selected: false },
                { name: '气象服务合作', subTitle: '主动气象为人民服务', src: './static/images/27.png', selected: false }
            ],
            imgIndex: 0,
            sysLists: [
                {
                    name: '气象业务', selected: true,
                    lists: [
                        '人工影响天气综合指挥平台',
                        '人工影响天气实景可视监控平台',
                        '人影综合指挥管理平台2.0',
                        '人影指挥中心软件系统',
                        '人工影响天气飞机增雨指挥平台',
                        '人影综合业务系统',
                        '内涝风险预警业务系统',
                        '防汛气象预报预警系统',
                        '基层风险预警预报平台',
                        '地质灾害气象预警平台',
                        '气象灾害监控系统',
                        '短时临近监测预警一体化业务系统',
                        '气候预测业务系统',
                        '延伸期预报业务平台',
                        'DERF2.0解释应用及其检验系统',
                        '智慧气象业务平台',
                        '多维精细化气象历史资料应用系统和样本资料处理系统',
                        '决策气象服务APP',
                        '专业气象APP',
                        '气象决策APP',
                        '气象决策服务系统'
                    ]
                },
                {
                    name: '气象+', selected: false, lists:
                        [
                            '气象局门户网站集群系统',
                            '天气雷达信息公众服务与预警系统',
                            '农业气象服务平台',
                            '天耕农业气象服务平台',
                            '智慧农业气象服务终端及支撑平台',
                            '三农气象服务平台',
                            '智慧农业气象服务APP',
                            '气象为农服务APP',
                            '交通预报服务能力建设系统',
                            '交通气象服务APP',
                            '全景气象公众版APP',
                            '西南石油管道气象服务平台',
                            '气象服务APP',
                            '气象公众版与应急版APP',
                            '气象局公共服务平台',
                            '气象服务终端APP',
                            '环境气象服务综合业务平台APP',
                            '气象APP',
                            '楚天气APP',
                            '乡镇级突发预警APP',
                            '天气公众气象服务APP',
                            '气象微信平台',
                            '预警发布微信公众平台',
                        ]
                }
            ]
        }
    },
    computed: {
        sysListpt() {
            let arr = [];
            this.sysLists.forEach(item => {
                if (item.selected) {
                    arr = item.lists;
                }
            });
            return arr;
        }
    },
    methods: {
        mapimgsChange(val) {
            this.mapimgs.forEach((item, index) => {
                item.selected = false;
                if (index === val) {
                    this.imgIndex = index;
                    item.selected = true;
                }
            })
        },
        sysListMainChange(val) {
            this.sysLists.forEach((item, index) => {
                item.selected = false;
                if (index === val) {
                    item.selected = true;
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
    .casePage {
        width: 100%;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        .content {
            flex: 1;
            padding: 0 20px;
            color: #ffffff;
            .title {
                width: 258px;
                position: relative;
                font-size: 30px;
                height: 70px;
                margin-top: 60px;
                em {
                    font-style: normal;
                    display: block;
                    font-size: 15px;
                }
                i {
                    display: inline-block;
                    width: 60px;
                    height: 1px;
                    background-color: #ffffff87;
                    position: absolute;
                    bottom: 2px;
                    right: 0px;
                }
                span {
                    display: inline-block;
                    width: 120px;
                    height: 1px;
                    background-color: #ffffff87;
                    position: absolute;
                    top: -2px;
                    left: 0px;
                }
            }
            .js {
                line-height: 30px;
                font-size: 15px;
                margin-top: 10px;
                letter-spacing: 1px;
            }
            .tabMain {
                margin-top: 60px;
                position: relative;
                height: 600px;
                .tabTitle {
                    .titles {
                        margin-top: 40px;
                        padding-left: 5px;
                        line-height: 25px;
                        position: relative;
                        height: 50px;
                        cursor: pointer;
                        p {
                            font-size: 30px;
                            margin: 0;
                            padding: 0;
                        }
                        span {
                            font-size: 15px;
                            position: absolute;
                            bottom: -5px;
                            left: 5px;
                        }
                        &.select {
                            border-left: 4px solid #0070E2;
                            p {
                                color: #0070E2;
                            }
                            span {
                                color: #0070E2;
                            }
                        }
                    }
                }
                .mapimg {
                    position: absolute;
                    top: -158px;
                    right: 0;
                }
            }
            .sysListMain {
                margin-top: 60px;
                .tabTitle {
                    .t {
                        display: inline-block;
                        border: 1px solid #ffffff87;
                        margin-right: 20px;
                        padding: 15px 30px;
                        color: #fff;
                        font-size: 24px;
                        cursor: pointer;
                        &.select {
                            background-color: #0070E2;
                            border: 1px solid #0070E2;
                        }
                    }
                }
                .lists {
                    margin-left: -2%;
                    margin-top: 25px;
                    .list {
                        margin-top: 25px;
                        float: left;
                        width: 31.333%;
                        margin-left: 2%;
                        i {
                            display: inline-block;
                            height: 20px;
                            width: 20px;
                            margin-right: 10px;
                            background-color: #0070E2;
                            vertical-align: -5px;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/case.vue